var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "event-modal",
      class: {
        "v--modal-box v--modal": _vm.isChangeOrder,
        "modal-delete": _vm.isDeleteModal
      },
      attrs: { name: "eventModal", height: _vm.calculateHeight, width: 700 },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c("div", { staticClass: "modal-header" }, [
        _c("div", { staticClass: "modal-header-text" }, [
          _c("span", [_vm._v(_vm._s(_vm.modalData.title))])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-body" },
        [
          _vm.modalData.modalAction == _vm.actionTypes.suggestChanges ||
          _vm.modalData.modalAction == _vm.actionTypes.reviewSuggestChanges
            ? _c("SuggestChanges")
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.showInfo
            ? _c("ChangeSubmitted")
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.submitEvent ||
          _vm.modalData.modalAction == _vm.actionTypes.reviewResubmit
            ? _c("SubmitEventModal", {
                attrs: { itemName: _vm.actionData.eventName }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.changeOrder
            ? _c("ChangeOrder", {
                attrs: { itemName: _vm.actionData.eventName }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.approveEvent
            ? _c("ApproveEvent")
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.deleteEvent
            ? _c("DeleteEvent")
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.someEmptyFields
            ? _c("SubmitAllEventEmptyFieldsError")
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.lessThan90Days
            ? _c("SubmitAllEvent90DaysError")
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction ==
          _vm.actionTypes.someEmptyFieldsOrLessThan90Days
            ? _c("SubmitAllEventEmptyFieldsAnd90DaysError")
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.eventPrefDateInvalid
            ? _c("EventTimeInvalid")
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.eventNameNotUnique ||
          _vm.modalData.modalAction == _vm.actionTypes.someFieldsBlank ||
          _vm.modalData.modalAction ==
            _vm.actionTypes.eventDurationRestricted ||
          _vm.modalData.modalAction == _vm.actionTypes.readOnly ||
          _vm.modalData.modalAction == _vm.actionTypes.deleteUser ||
          _vm.modalData.modalAction == _vm.actionTypes.deleteValidator ||
          _vm.modalData.modalAction == _vm.actionTypes.emailIsNotValid ||
          _vm.modalData.modalAction == _vm.actionTypes.deleteClient
            ? _c("ModalInfoBody", { attrs: { messages: _vm.bodyMessage } })
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.submitAllError
            ? _c("ModalBodyWithErrorCodes", {
                attrs: { messages: _vm.bodyMessageWithErrorCode }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.addClient
            ? _c("AddClient", {
                attrs: { clientInfo: _vm.clientInfo },
                on: { disableBtnRight: _vm.setDisableButtonRight }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.createUser ||
          _vm.modalData.modalAction == _vm.actionTypes.editUser
            ? _c("UserInfo", {
                attrs: {
                  modalAction: _vm.modalData.modalAction,
                  userInfo: _vm.actionData,
                  modalDataValid: _vm.modalDataValid
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.resetPassword
            ? _c("ResetPasswordModal", {
                attrs: { resetPasswordInfo: _vm.resetPasswordInfo },
                on: { disableBtnRight: _vm.setDisableButtonRight }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.moveEvent
            ? _c("MoveEvent", { attrs: { moveEventData: _vm.moveEventData } })
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.forceUserResetPassword
            ? _c("ForceUserResetPassword", { attrs: { userId: _vm.userId } })
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.modalAction == _vm.actionTypes.createValidator ||
          _vm.modalData.modalAction == _vm.actionTypes.editValidator
            ? _c("AddValidator", {
                attrs: { validatorInfo: _vm.validatorInfo }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-footer" },
        [
          _vm.modalData.btnLeft != ""
            ? _c(
                "b-button",
                {
                  staticClass: "modal-btn-left ap-btn secondary",
                  on: {
                    click: function($event) {
                      _vm.hideModal()
                    }
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.modalData.btnLeft) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.btnRight != ""
            ? _c(
                "b-button",
                {
                  staticClass: "modal-btn-right ap-btn primary",
                  attrs: { disabled: _vm.disableButtonRight },
                  on: {
                    click: function($event) {
                      _vm.btnAction()
                    }
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.modalData.btnRight) + "\n    ")]
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-59073bd1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59073bd1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/Modal.vue
// module id = 1435
// module chunks = 1